import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-lockout',
    templateUrl: './lockout.component.html',
    styleUrls: ['./lockout.component.scss'],
    standalone: false
})
export class LockoutComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.clearUser();
    localStorage.removeItem('swirl-token');
    sessionStorage.clear();
  }

}
